import axios from "axios";
import Cookie from "js-cookie";
const _ = require("lodash");

const backendPath = Cookie.get("backendPath");

const axiosConfig = {
  baseURL: _.defaultTo(backendPath, process.env.VUE_APP_BASE_URL)
};

const axiosInstance = axios.create(axiosConfig);

axiosInstance.interceptors.request.use(
  config => {
    config.headers.Authorization = `Bearer ${Cookie.get("authToken")}`;
    return config;
  },
  error => Promise.reject(error)
);

export default axiosInstance;
